import { atom } from 'jotai';
import { SettingsProtocolsGetProfileResponse } from '~/swagger/data-contracts';
import { getStorageBrandId } from '~/utils';
import { BrandFilterMode } from '~/types/common';

export const userProfileAtom = atom<SettingsProtocolsGetProfileResponse | undefined>(undefined);

export const selectedBrandIdAtom = atom<number | undefined>();
selectedBrandIdAtom.onMount = (setAtom) => {
  const brandId = getStorageBrandId();
  setAtom(brandId);
};

export const brandFilterModeAtom = atom<BrandFilterMode>('enabled');

type Alert = {
  type: 'unpaid';
  count: number;
  excludedRoutes?: string[]; // 노출을 제외할 라우트 리스트
};
type AlertAtom = {
  list: Alert[];
};
const initialAlertAtom: AlertAtom = {
  list: [],
};
export const alertAtom = atom<AlertAtom>(initialAlertAtom);

// 현재 라우트에서 보여줄 첫번째 alert 아이템을 가져오는 selector
export const firstAlertAtom = atom((get) => {
  const alert = get(alertAtom);
  return alert.list[0];
});

// alert를 추가하는 selector
export const addAlertAtom = atom(null, (get, set, newAlert: Alert) => {
  const currentAlert = get(alertAtom);
  const updatedList = currentAlert.list.filter((alert) => alert.type !== newAlert.type);
  updatedList.push(newAlert);
  set(alertAtom, { list: updatedList });
});

// 특정 타입의 alert를 제거하는 selector
export const removeAlertByTypeAtom = atom(null, (get, set, alertType: Alert['type']) => {
  const currentAlert = get(alertAtom);
  const updatedList = currentAlert.list.filter((alert) => alert.type !== alertType);
  set(alertAtom, { list: updatedList });
});
